<template>
  <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel"
    width="840px" class="bom-base-form">
    <a-form :model="formState" :rules="baseFormRules" ref="formRef"
      :label-col="{ style: { width: '120px', marginTop: '10px' } }"
      :wrapper-col="{ style: { width: '260px', marginTop: '10px' } }" layout="inline">
      <a-form-item label="选择物料" :wrapper-col="{ style: { width: '600px', marginTop: '10px' } }" name="materialId">
        <a-space>
          <!-- <a-select
            v-model:value="searchMaterial"
            show-search
            placeholder="请输入物料名称"
            style="width: 300px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            not-found-content="无数据"
            :options="materialData"
            allowClear
            @search="handleSearch"
            @change="handleChange"
            :dropdownMatchSelectWidth="false"
          >
          </a-select> -->

          <a-select v-model:value="searchMaterial" show-search placeholder="请输入物料编码/名称/规格/型号" style="width: 400px"
            @change="handleChange" allowClear :options="materialData" optionFilterProp="search">
          </a-select>

          <a-select :options="materialTypeOptins" v-model:value="searchMaterialType" style="width: 160px" allowClear
            @change="handleMaterialChange" placeholder="类型">
          </a-select>
        </a-space>
      </a-form-item>

      <a-form-item label="物料编码" name="materialCode">
        <a-input v-model:value="material.materialCode" placeholder="物料编码" disabled></a-input>
      </a-form-item>

      <a-form-item label="物料名称" name="materialName">
        <a-input v-model:value="material.materialName" placeholder="物料名称" disabled></a-input>
      </a-form-item>
      <a-form-item label="物料分类" name="materialSort">
        <a-input v-model:value="material.materialSort" placeholder="物料分类" disabled></a-input>
      </a-form-item>
      <a-form-item label="物料型号" name="type">
        <a-input v-model:value="material.materialModel" placeholder="物料型号" disabled></a-input>
      </a-form-item>
      <a-form-item label="规格" name="specification">
        <a-input v-model:value="material.specification" placeholder="规格" disabled></a-input>
      </a-form-item>
      <!-- <a-form-item label="物料名称">
        <a-input
          v-model:value="material.materialName"
          placeholder="物料名称"
          disabled
        ></a-input>
      </a-form-item> -->
      <a-form-item label="属性" name="attribute">
        <a-input v-model:value="material.attribute" placeholder="属性" disabled></a-input>
      </a-form-item>
      <a-form-item label="版本" name="edition">
        <a-input v-model:value="material.edition" placeholder="版本" disabled></a-input>
      </a-form-item>
      <a-form-item label="代码" name="code">
        <a-input v-model:value="material.code" placeholder="代码" disabled></a-input>
      </a-form-item>
      <a-form-item label="单位" name="unit">
        <a-input v-model:value="material.unit" placeholder="单位" disabled></a-input>
      </a-form-item>

      <a-form-item :label="props.seriesNameConfig.seriesOneName || '系列1数量'">
        <a-input v-model:value="formState.seriesOneQuantity"
          :placeholder="props.seriesNameConfig.seriesOneName ? `请输入${props.seriesNameConfig.seriesOneName}数量` : '请输入系列1数量'"
          @change="handleCheckNumber($event, 'seriesOneQuantity')" allowClear></a-input>
      </a-form-item>

      <a-form-item label="检验">
        <a-select v-model:value="formState.inspect" allowClear placeholder="检验" @change="handleInspectChange">
          <a-select-option value="抽检">抽检</a-select-option>
          <a-select-option value="全检">全检</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="props.seriesNameConfig.seriesTwoName || '系列2数量'">
        <a-input v-model:value="formState.seriesTwoQuantity"
          :placeholder="props.seriesNameConfig.seriesTwoName ? `请输入${props.seriesNameConfig.seriesTwoName}数量` : '请输入系列2数量'"
          @change="handleCheckNumber($event, 'seriesTwoQuantity')" allowClear></a-input>
      </a-form-item>

      <a-form-item label="备注">
        <a-textarea v-model:value="formState.notes" placeholder="备注" auto-size allowClear>
        </a-textarea>
      </a-form-item>
      <a-form-item :label="props.seriesNameConfig.seriesThreeName || '系列3数量'">
        <a-input v-model:value="formState.seriesThreeQuantity"
          :placeholder="props.seriesNameConfig.seriesThreeName ? `请输入${props.seriesNameConfig.seriesThreeName}数量` : '请输入系列3数量'"
          @change="handleCheckNumber($event, 'seriesThreeQuantity')" allowClear></a-input>
      </a-form-item>
      <a-form-item label="bom框架">
        <a-switch checked-children="是" un-checked-children="否" v-model:checked="formState.isFrame" />
      </a-form-item>
      <a-form-item :label="props.seriesNameConfig.seriesFourName || '系列4数量'">
        <a-input v-model:value="formState.seriesFourQuantity"
          :placeholder="props.seriesNameConfig.seriesFourName ? `请输入${props.seriesNameConfig.seriesFourName}数量` : '请输入系列4数量'"
          @change="handleCheckNumber($event, 'seriesFourQuantity')" allowClear></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { insertBOMData, updateBOMDataList } from "@/request/view/project";
import { materialTypeOptins } from "@/views/materialcode/options";
import { debounce, Toast } from "@/utils";
import { useMaterial } from "@/views/rdmanagement/components/bom/serve/material";

export default defineComponent({
  props: {
    seriesNameConfig: Object,
  },
  setup(props, context) {
    const route = useRoute();
    const store = useStore();
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });
    // 表单数据
    const formState = reactive({
      id: null,
      inspect: null,
      materialModelCodeId: null,
      notes: null,
      pid: 0,
      projectLifeCycleId: null,
      seriesOneQuantity: null,
      seriesTwoQuantity: null,
      seriesThreeQuantity: null,
      seriesFourQuantity: null,
      structureName: null,
      userId: null,
      username: null,
      bomFrameName: null,
      isFrame: false,
    });

    const {
      material,
      materialData,
      searchMaterial,
      searchMaterialType,
      setMaterialType,
      findMaterialData,
      initSearchData,
      resetMaterialData,
      checkSelectedInData,
    } = useMaterial();

    const formRef = ref();

    // 设置记录的 structureName username userId projectLifeCycleId
    const setRecordByUser = () => {
      const { nickName, id, secondaryDepartment, firstLevelDepartment } =
        store.state.user.user;
      formState.structureName = secondaryDepartment || firstLevelDepartment;

      formState.username = nickName;
      formState.userId = id;
      formState.projectLifeCycleId = route.query.projectId;
    };

    const showModal = (options) => {
      // 获取物料
      initSearchData();
      const { title, type, data, materialClassification } = options;

      modalConfig.title = title;
      modalConfig.type = type;
      // 编辑回显数据
      if (type === "edit") {
        // 回显选中的物料
        searchMaterial.value = `${data.materialName}${data.materialModel ? data.materialModel : ''}`;
        Object.keys(material).forEach((key) => {
          material[key] = data[key];
        });
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
      // 添加子项
      if (type === "addchild") {
        formState.pid = data.id;
        setRecordByUser();
      }
      // 添加
      if (type === "add") {
        formState.pid = 0;
        setRecordByUser();
      }
      // 物料分类
      formState.bomFrameName = materialClassification;
      modalConfig.visible = true;

      console.log(formState, '表单的数据是');
    };

    // 重置请求表单
    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });

      formState.pid = 0;
      formState.isFrame = false;

      searchMaterial.value = null;
      searchMaterialType.value = undefined;
    };

    const closeModal = () => {
      // 重置物料数据
      resetMaterialData();
      // 重置表单
      resetForm();
      modalConfig.visible = false;
    };

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          let reqFn = insertBOMData;
          let data = formState;

          if (modalConfig.type === "edit") {
            reqFn = updateBOMDataList;
            data = [formState];
          }

          reqFn(data)
            .then((res) => {
              const type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              context.emit("updateTable", formState.bomFrameName);
              closeModal();
            })
            .catch((err) => { });
        })
        .catch((err) => {
          console.log(err);
          if (err.errorFields) {
            const errText = err.errorFields[0].errors[0];
            Toast("warning", errText, 3);
          }
        });
    }, 50);

    // 搜索
    const handleSearch = (val) => {
      searchMaterial.value = val;
    };
    // 重置选中的物料
    const resetSelectMaterial = () => {
      Object.keys(material).forEach((key) => {
        material[key] = null;
      });
      formState.materialModelCodeId = null;
      searchMaterial.value = undefined;
    };
    // 清除表单数据
    const handleCancel = () => {
      resetSelectMaterial();
      resetForm();
    };
    const handleChange = (val, options) => {
      if (val === undefined) {
        resetSelectMaterial();
        initSearchData();
        return;
      }

      searchMaterial.value = val;

      formState.materialModelCodeId = val;

      Object.keys(material).forEach((key) => {
        material[key] = options[key];
      });

      formState.isFrame = options.type.indexOf("P") !== -1;
    };

    const handleCheckNumber = (e, type) => {
      if (!formState[type]) {
        formState[type] = null;
        return;
      }

      if (isNaN(Number(formState[type]))) {
        formState[type] = null;
      } else {
        formState[type] = Number(formState[type]);
      }
    };

    const handleMaterialChange = (e) => {
      resetSelectMaterial();
      findMaterialData();
    };

    const checkmaterialRequire = async (rule, value) => {
      const { field, message } = rule;
      if (!formState.materialModelCodeId) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    };

    const checkMaterialId = async (rule, value) => {
      const { field, message } = rule;
      if (!formState.materialModelCodeId) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    };

    const handleInspectChange = (e) => {
      formState.inspect = e;
    };

    const baseFormRules = {
      materialId: [
        {
          required: true,
          message: "请选择物料",
          trigger: "change",
          validator: checkMaterialId,
        },
      ],
      // materialCode: [
      //   {
      //     required: true,
      //     message: "请选择物料编码",
      //     trigger: "change",
      //     validator: checkmaterialRequire,
      //   },
      // ],
      // materialName: [
      //   {
      //     required: true,
      //     message: "请选择物料名称",
      //     trigger: "change",
      //     validator: checkmaterialRequire,
      //   },
      // ],
      // materialSort: [
      //   {
      //     required: true,
      //     message: "请选择物料分类",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // type: [
      //   {
      //     required: true,
      //     message: "请选择物料类型",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // materialModel: [
      //   {
      //     required: true,
      //     message: "请选择物料规格",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // attribute: [
      //   {
      //     required: true,
      //     message: "请选择物料属性",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // edition: [
      //   {
      //     required: true,
      //     message: "请选择物料版本",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // code: [
      //   {
      //     required: true,
      //     message: "请选择物料代码",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
      // unit: [
      //   {
      //     required: true,
      //     message: "请选择物料单位",
      //     trigger: "change",
      //     type: "string",
      //   },
      // ],
    };
    return {
      searchMaterialType,
      materialTypeOptins,
      modalConfig,
      searchMaterial,
      materialData,
      props,
      showModal,
      handleOk,
      handleCancel,
      material,
      handleSearch,
      debounce,
      handleMaterialChange,
      handleCheckNumber,
      handleChange,
      formState,
      formRef,
      baseFormRules,
      handleInspectChange,
    };
  },
});
</script>

<style lang="less">
.bom-base-form {
  .ant-form-inline .ant-form-item-with-help {
    margin-bottom: 0px;
  }
}
</style>